import styled from 'styled-components';
import { Divider } from 'antd';


export const PaymentCardWrapper = styled.div`
  height: 207px;
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px ${props => props.theme.backgroundColor.layoutDark};
  background-color: ${props => props.theme.backgroundColor.tableAltRowDark};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    height: 133px;
  }
`;

export const PaymentContentWrapper = styled.div`
  margin: 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 15px 16px 20px 16px;
  }
`

export const PaymentInfoContent = styled.div`
  font-family: ${props=>props.theme.fontFamily.berkeleyStd};
  font-size: ${props=>props.theme.fontSize.heading};
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: ${props=>props.theme.lineHeight.normal};
  letter-spacing: ${props=>props.theme.letterSpacing.zero};
  color: ${props=>props.theme.fontColors.textColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props=>props.theme.fontSize.secondary};
  }
`
export const PaymentDivider = styled(Divider)`
&&&
.ant-divider, 
  .ant-divider-horizontal{
  margin: 0;
  margin-top: 14.5px;
  margin-bottom: 14.5px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 11.5px;
    margin-bottom: 9.5px;
  }
}
`
export const PaymentAmount = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.h4};
  font-style: normal;
  font-stretch: normal;
  line-height: ${props => props.theme.lineHeight.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props=>props.theme.fontColors.primary};
  margin-top: 5px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    color: ${props=>props.theme.fontColors.textColor};
    font-size: ${props=>props.theme.fontSize.h5};
    margin-top: 0px;
  }
`
